(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-recipe"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rcp-print]')) window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-a-box"] && !Shopify.designMode) return;
  try {
    
  // Liquid is not rendered in here, so every value comes off data attributes.
  (function () {
    var root = document.querySelector('[data-bab]');
    if (!root) return;

    function tierPct() {
      var on = root.querySelector('.bab__tier.on');
      return parseFloat(on && on.dataset.pct) / 100 || 0;
    }
    var THRESHOLD = parseInt(root.dataset.threshold, 10) || 0;
    var slotsEl = root.querySelector('[data-slots]');
    var live = root.querySelector('[data-live]');
    var addBtn = root.querySelector('[data-add]');
    var needEl = root.querySelector('[data-need]');
    var fillBtn = root.querySelector('[data-fill]');
    var jars = Array.prototype.slice.call(root.querySelectorAll('[data-jar]'));

    var tier = parseInt(root.querySelector('.bab__tier.on').dataset.tier, 10);
    // Fixed length WITH HOLES. Splicing makes the gap appear at the end rather than
    // where the shopper clicked, which reads as the box rearranging itself.
    var box = new Array(tier).fill(null);

    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function filled() { return box.filter(Boolean); }
    function nextEmpty() { return box.indexOf(null); }

    function say(msg) { if (live) live.textContent = msg; }

    function render() {
      slotsEl.innerHTML = '';
      var next = nextEmpty();
      box.forEach(function (item, i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bab__slot' + (item ? ' bab__slot--full' : (i === next ? ' bab__slot--next' : ''));
        if (item) {
          b.setAttribute('aria-label', 'Remove ' + item.title + ' from slot ' + (i + 1));
          if (item.img) { var im = new Image(); im.src = item.img; im.alt = ''; b.appendChild(im); }
          b.addEventListener('click', function () {
            box[i] = null;                       // the slot you click is the slot that empties
            say(item.title + ' removed. ' + filled().length + ' of ' + tier + ' chosen.');
            render();
          });
        } else if (i === next) {
          b.setAttribute('aria-label', 'Choose jar ' + (i + 1) + ' of ' + tier);
          b.addEventListener('click', function () { if (jars[0]) jars[0].focus(); });
        } else {
          b.disabled = true;                     // inert slots stay out of the tab order
          b.setAttribute('aria-hidden', 'true');
        }
        var n = document.createElement('span');
        n.className = 'bab__slot-n';
        n.textContent = ('0' + (i + 1)).slice(-2);
        b.appendChild(n);
        li.appendChild(b);
        slotsEl.appendChild(li);
      });

      var picked = filled();
      var gross = picked.reduce(function (t, x) { return t + x.price; }, 0);
      var pct = tierPct();
      // Shopify FLOORS the allocation on each line, so the box total is
      // sum(floor(line * pct)) and not round(gross * pct). Measured on a real cart:
      // four jars at 3596 gross gave 536, which is the sum of the floors; rounding
      // the sum gives 539 and rounding each line gives 540. A builder that promises
      // $30.57 and charges $30.60 is a builder nobody trusts twice.
      var save = 0;
      for (var si = 0; si < picked.length; si++) save += Math.floor(picked[si].price * pct);
      var total = gross - save;
      root.querySelector('[data-sum-count]').textContent = picked.length + ' of ' + tier;
      root.querySelector('[data-sum-pct]').textContent = Math.round(pct * 100) + '% off';
      root.querySelector('[data-sum-gross]').textContent = picked.length ? money(gross) : '—';
      root.querySelector('[data-sum-save]').textContent = picked.length ? '−' + money(save) : '—';
      root.querySelector('[data-sum-total]').textContent = picked.length ? money(total) : '—';

      var ship = root.querySelector('[data-ship]');
      if (!picked.length || !THRESHOLD) ship.textContent = '';
      else if (total >= THRESHOLD) ship.textContent = 'Ships free.';
      else ship.textContent = money(THRESHOLD - total) + ' more and it ships free.';

      var full = picked.length === tier;
      addBtn.disabled = !full;
      if (full) addBtn.textContent = 'Add ' + tier + ' jars · ' + money(total);
      else { addBtn.textContent = 'Pick '; needEl = document.createElement('span');
             needEl.textContent = (tier - picked.length); addBtn.appendChild(needEl);
             addBtn.appendChild(document.createTextNode(' more to fill your box')); }
    }

    jars.forEach(function (j) {
      j.addEventListener('click', function () {
        var i = nextEmpty();
        if (i === -1) { say('Your box is full. Remove a jar to swap it.'); return; }
        box[i] = { id: j.dataset.id, title: j.dataset.title, price: parseInt(j.dataset.price, 10), img: j.dataset.img };
        var left = tier - filled().length;
        say(j.dataset.title + ' added. ' + filled().length + ' of ' + tier + ' chosen. ' +
            (left ? left + ' to go.' : 'Box full.'));
        render();
      });
    });

    root.querySelectorAll('.bab__tier').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.bab__tier').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var picked = filled();
        tier = parseInt(t.dataset.tier, 10);
        box = new Array(tier).fill(null);
        picked.slice(0, tier).forEach(function (item, i) { box[i] = item; });  // keep what fits
        say('Box size ' + tier + ' jars, ' + Math.round(tierPct() * 100) + '% off. '
            + filled().length + ' chosen.');
        render();
      });
    });

    fillBtn.addEventListener('click', function () {
      // One of each line first, then round-robin, so truncating a bigger box to a
      // smaller one still leaves a spread rather than eight of one thing.
      var byLine = {};
      jars.forEach(function (j) {
        var g = j.closest('.bab__grid');
        var key = g ? Array.prototype.indexOf.call(g.parentNode.children, g) : 0;
        (byLine[key] = byLine[key] || []).push(j);
      });
      var lines = Object.keys(byLine).map(function (k) { return byLine[k]; });
      box = new Array(tier).fill(null);
      var i = 0, round = 0;
      while (i < tier && round < 20) {
        for (var L = 0; L < lines.length && i < tier; L++) {
          var j = lines[L][round];
          if (!j || j.disabled) continue;
          box[i++] = { id: j.dataset.id, title: j.dataset.title, price: parseInt(j.dataset.price, 10), img: j.dataset.img };
        }
        round++;
      }
      say('Filled with ' + filled().length + ' jars, spread across the lines.');
      render();
    });

    addBtn.addEventListener('click', function () {
      var picked = filled();
      if (picked.length !== tier) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      var counts = {};
      picked.forEach(function (p) { counts[p.id] = (counts[p.id] || 0) + 1; });
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: Object.keys(counts).map(function (id) { return { id: id, quantity: counts[id] }; }) })
      }).then(function (r) { if (!r.ok) throw new Error(); window.location = '/cart'; })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Could not add — try again'; });
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Header navigation behaviour.
  //
  // Everything here is progressive enhancement. Without JS the desktop panel
  // still opens on hover and on keyboard focus (:focus-within), and the mobile
  // drawer's <details> groups still expand. JS adds only what markup cannot:
  // aria-expanded, Escape, outside-click, scroll lock and focus return.
  //
  // Section JS is injected via content_for_header — in <head>, before the body
  // exists — so everything waits for the DOM.
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }

    ready(function () {
      var header = document.querySelector('.site-header');
      if (!header) return;

      // ---------- desktop mega ----------
      var megas = Array.prototype.slice.call(header.querySelectorAll('[data-mega]'));

      function closeMega(m, returnFocus) {
        var btn = m.querySelector('[data-mega-toggle]');
        m.classList.remove('is-open');
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
          if (returnFocus) btn.focus();
        }
      }

      function closeAllMegas(except) {
        megas.forEach(function (m) { if (m !== except) closeMega(m, false); });
      }

      megas.forEach(function (m) {
        var btn = m.querySelector('[data-mega-toggle]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          closeAllMegas(m);
          m.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });
      });

      // ---------- mobile drawer ----------
      var navBtn = header.querySelector('[data-nav-toggle]');
      var navPanel = header.querySelector('[data-nav-panel]');

      function setDrawer(open) {
        if (!navBtn || !navPanel) return;
        navBtn.setAttribute('aria-expanded', String(open));
        if (open) navPanel.setAttribute('data-open', '');
        else navPanel.removeAttribute('data-open');
        // Lock the page behind the drawer, not the drawer itself — it scrolls.
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }

      if (navBtn && navPanel) {
        navBtn.addEventListener('click', function () {
          setDrawer(navBtn.getAttribute('aria-expanded') !== 'true');
        });
        // A link inside the drawer navigates; leaving it open behind the new
        // page would strand the scroll lock.
        navPanel.addEventListener('click', function (e) {
          if (e.target.closest('a')) setDrawer(false);
        });
      }

      // ---------- global dismissal ----------
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openMega = header.querySelector('[data-mega].is-open');
        if (openMega) { closeMega(openMega, true); return; }
        if (navBtn && navBtn.getAttribute('aria-expanded') === 'true') {
          setDrawer(false);
          navBtn.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!header.contains(e.target)) {
          closeAllMegas(null);
          if (navBtn && navBtn.getAttribute('aria-expanded') === 'true') setDrawer(false);
        }
      });

      // Crossing the breakpoint with the drawer open would hide it while the
      // scroll lock stayed applied.
      var mq = window.matchMedia('(min-width: 861px)');
      var onChange = function (e) { if (e.matches) setDrawer(false); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  // Pre-fill the search box from the dead URL.
  //   /products/carolina-reaper  →  "carolina reaper"
  //
  // Must be client-side: Liquid's request.path is "/404" here, not the requested
  // URL. window.location.pathname still holds the real one.
  // Section JS is injected via content_for_header, i.e. in <head> BEFORE the body
  // exists — so this must wait for the DOM or it queries an empty document.
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-e404-prefill]');
    if (!root) return;
    var input = root.querySelector('input[name="q"]');
    if (!input || input.value) return;

    var seg = (window.location.pathname || '').split('/').filter(Boolean).pop() || '';

    // Guards: skip the site root, Shopify's own 404 route, anything absurdly
    // long, and anything with no letters in it (ids, hashes, file extensions).
    if (!seg || seg === '404' || seg.length > 40) return;
    if (!/[a-z]/i.test(seg)) return;

    var guess = decodeURIComponent(seg).replace(/[-_]+/g, ' ').replace(/\.[a-z0-9]{2,4}$/i, '').trim();
    if (guess.length > 1) input.value = guess;

    // Record the dead URL on the capture too — same reason, request.path is "/404"
    // so a Liquid value would tag every signup identically and tell us nothing.
    var note = root.querySelector('input[name="contact[note]"]');
    if (note && !note.value) note.value = 'dead url: ' + window.location.pathname;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Heat sort, client-side. Reads the level straight off each card's
  // aria-label ("Heat 3 of 4, Gale") so it needs no extra data attribute and
  // stays correct if the card markup changes shape.
  (function () {
    function ready(fn){ document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
    ready(function () {
      var wrap = document.querySelector('[data-cgrid-sort]');
      var grid = document.querySelector('[data-cgrid-grid]');
      if (!wrap || !grid) return;
      wrap.hidden = false;                       // only offered when JS can deliver it

      var cards = Array.prototype.slice.call(grid.children);
      var original = cards.slice();
      function heatOf(card) {
        var el = card.querySelector('[role="img"][aria-label^="Heat"]');
        if (!el) return -1;                      // no heat: always sorts last
        var m = el.getAttribute('aria-label').match(/Heat (\d)/);
        return m ? parseInt(m[1], 10) : -1;
      }

      wrap.querySelector('[data-cgrid-select]').addEventListener('change', function (e) {
        var v = e.target.value, out;
        if (v === 'default') {
          out = original;
        } else {
          out = original.slice().sort(function (a, b) {
            var ha = heatOf(a), hb = heatOf(b);
            if (ha === -1) return 1;
            if (hb === -1) return -1;
            return v === 'asc' ? ha - hb : hb - ha;
          });
        }
        var frag = document.createDocumentFragment();
        out.forEach(function (c) { frag.appendChild(c); });
        grid.appendChild(frag);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  // Build the TOC from the rendered H2s and give each a slugged id, so support
  // can link to /pages/shipping#international instead of "scroll down a bit".
  // Section JS is injected via content_for_header, i.e. in <head> BEFORE the body
  // exists — so this must wait for the DOM or it queries an empty document.
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var content = document.querySelector('[data-pg-content]');
    var toc = document.querySelector('[data-pg-toc]');
    if (!content || !toc) return;

    var list = toc.querySelector('[data-pg-toc-list]');
    var headings = content.querySelectorAll('h2');
    if (headings.length < 3) return;

    var used = {};
    headings.forEach(function (h) {
      var slug = (h.textContent || '')
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-');
      if (!slug) return;
      if (used[slug]) {
        used[slug] += 1;
        slug = slug + '-' + used[slug];
      } else {
        used[slug] = 1;
      }
      if (!h.id) h.id = slug;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });

    if (list.children.length) toc.hidden = false;
  });

  } catch(e) { console.error(e); }
})();
})();
